import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const PurchasedImages = () => {
    const { id } = useParams(); // Get the vehicle ID from the URL
    const navigate = useNavigate();
    const [images, setImages] = useState([]); // Store all images (main image + additional images)
    const [vehicleDetails, setVehicleDetails] = useState({}); // Store vehicle details
    const [error, setError] = useState(null);
    const [userType, setUserType] = useState("");
    const [userFullName, setUserFullName] = useState("");

    useEffect(() => {
        // Get user data from localStorage
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lName");

        if (!storedUserType) {
            navigate("/login"); // Redirect if not logged in
        } else {
            setUserType(storedUserType);
            // Combine first and last name if available
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    useEffect(() => {
        console.log('Fetching images for ID:', id);
        const fetchImages = async () => {
            try {
                const response = await axios.get(`https://api.saadmotors.com/fetch_purchased_images.php?car_id=${id}`);
                console.log('Images Response:', response.data);
                if (response.data && response.data.mainImage && Array.isArray(response.data.additionalImages) && response.data.carDetails) {
                    const allImages = [response.data.mainImage, ...response.data.additionalImages];
                    setImages(allImages);
                    setVehicleDetails(response.data.carDetails);
                    setError(null);
                } else {
                    console.error('Invalid response format:', response.data);
                    setImages([]);
                    setVehicleDetails({});
                    setError('Failed to load images: Invalid API response');
                }
            } catch (error) {
                console.error('Error fetching images:', error);
                setImages([]);
                setVehicleDetails({});
                setError('Failed to load images: Network or server error');
            }
        };

        fetchImages();
    }, [id]);

    const handleBack = () => {
        navigate(-1); // Navigate back to the previous page (PurchasedVehicles)
    };

    const handleBulkDownload = async () => {
        try {
            const response = await axios.get(`https://api.saadmotors.com/download_purchased_zip.php?car_id=${id}`, {
                responseType: 'blob' // Important for handling binary data (ZIP file)
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `purchased_vehicle_${id}_images.zip`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading ZIP:', error);
            alert('Failed to download ZIP file. Please check the console for details.');
        }
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel, {userFullName}</h1>
                    <button onClick={handleBack} className="btn btn-secondary mr-2">
                        Back to Purchased Vehicles
                    </button>
                    <button onClick={handleBulkDownload} className="btn btn-primary">
                        Download All Images (ZIP)
                    </button>
                </div>

                <div className="mainsection">
                    <h3>
                        Purchased Vehicle Images (Vehicle ID: {id})
                        {vehicleDetails.stock_id && (
                            <span style={{ fontSize: '1rem', color: '#666', marginLeft: '10px' }}>
                                | Stock ID: {vehicleDetails.stock_id} | VIN: {vehicleDetails.vin} | {vehicleDetails.maker} {vehicleDetails.model}
                            </span>
                        )}
                    </h3>
                </div>

                <div className="container">
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}

                    {images.length > 0 ? (
                        <div className="row">
                            {images.map((image, index) => (
                                image ? (
                                    <div key={index} className="col-md-4 mb-4">
                                        <div className="card">
                                            <img
                                                src={`https://api.saadmotors.com/${image}`}
                                                alt={`Vehicle Image ${index + 1}`}
                                                className="card-img-top"
                                                style={{ height: '200px', objectFit: 'cover' }}
                                            />
                                            <div className="card-body">
                                                <p className="card-text text-center">
                                                    Image {index + 1}
                                                </p>
                                                <button
                                                    className="btn btn-success btn-sm w-100 mt-2"
                                                    onClick={() => {
                                                        const link = document.createElement('a');
                                                        link.href = `https://api.saadmotors.com/${image}`;
                                                        link.setAttribute('download', `purchased_vehicle_${id}_image_${index + 1}.jpg`);
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                                    }}
                                                >
                                                    Download
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                            ))}
                        </div>
                    ) : (
                        <p className="text-center">No images available for this vehicle.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PurchasedImages;